<template>
  <div
    class="dnl:min-h-[65px] dnl:grid dnl:grid-cols-3 dnl:px-4 dnl:py-3 dnl:items-center dnl:sticky dnl:top-0 dnl:z-50 dnl:bg-white dnl:shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] dnl:border-b dnl:border-b-slate-100 dnl:border-b-solid"
  >
    <router-link
      v-if="!isLeftBreadCrumbs"
      title="Home"
      :to="user ? '/' : '/login'"
      data-testId="home"
      class="dnl:justify-self-start"
    >
      <img
        v-if="user && user.userGroup"
        :src="logoUrl"
        :alt="user.userGroup"
        class="dnl:h-6"
      />
      <img
        v-else
        src="@/assets/icon-br-m.png"
        alt="DNL logo"
        class="dnl:h-8"
      />
    </router-link>

    <BreadCrumbs
      v-if="breadcrumbsStore.breadcrumbs.length > 0"
      :breadcrumbs="breadcrumbsStore.breadcrumbs"
      :class="{
        'dnl:col-start-1': isLeftBreadCrumbs,
        'dnl:col-start-2 dnl:justify-self-center': !isLeftBreadCrumbs,
      }"
    />

    <AuditTypeSwitcher
      v-if="showAuditSwitcher && isLeftBreadCrumbs"
      v-model:type="currentAuditType"
      class="dnl:col-start-2 dnl:justify-self-center"
    />

    <AppBarMenu class="dnl:col-start-3 dnl:justify-self-end" />
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref } from 'vue';
  import { useRoute } from '@/utils/router';
  import BreadCrumbs from '@/components/Shared/BreadCrumbs.vue';
  import defaultLogo from '@/assets/icon-br-m.png';
  import { breadcrumbsStore } from '@/services/breadcrumbs.service';
  import { user } from '@/store/modules/auth/auth-state';
  import AppBarMenu from '@/components/Shared/AppBar/AppBarMenu.vue';
  import AuditTypeSwitcher from './AuditTypeSwitcher.vue';

  const route = useRoute();
  const currentAuditType = ref<'checklist' | 'evidence'>('checklist');

  const logoUrl = computed(() => user.value?.userGroupLogoURL || defaultLogo);
  const isLeftBreadCrumbs = computed(() => route.meta.leftBreadCrumbs || false);

  const routesWithSwitcher = [
    'annex-questions-audit',
    'annex-questions-review',
    'annex-audit-numbers',
    'annex-review-numbers',
  ] as const;

  const showAuditSwitcher = computed(() =>
    routesWithSwitcher.includes(route.name as (typeof routesWithSwitcher)[number]),
  );
</script>
